import React from "react";

const tabLabels = [
  "Incomplete Requirements",
  "Overdue Requirements",
  "Escalated Requirements",
  "Submitted Requirements",
  "Completed Requirements",
  "Archived Surveys",
];

const RequirementsTabs = ({ handleTabChange, currentTabIndex }) => {
  return (
    <div className="w-full">
      <div className="flex border-b border-gray-300">
        {tabLabels.map((label, index) => (
          <button
            key={index}
            onClick={(e) => handleTabChange(e, index)}
            className={`py-2 px-4 text-xs font-medium uppercase focus:outline-none transition-colors ${
              currentTabIndex === index
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-600 hover:text-blue-600"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RequirementsTabs;
